// Presentation metadata only. Point values and table links are retrieved live from
// the dashboard's /indicators/nsduh-treatment endpoint; no estimates are stored
// in this front-end module.
export const NSDUH_TREATMENT_SERIES = {
  id: "nsduhTreatment",
  selectionValue: "national:nsduhTreatment",
  label: "Adults with serious thoughts of suicide who received mental health treatment",
  shortLabel: "Treatment",
  metric: "Past-year receipt of any mental health treatment among adults aged 18+ who had serious thoughts of suicide in the past year",
  valueLabel: "Percent",
  valueFormat: "percent",
  geography: "national",
  definition: "This measure reports any mental health treatment received in the past year. It does not indicate that treatment was specifically for suicidal thoughts.",
  comparabilityNote: "Lines are intentionally broken where NSDUH collection methods or treatment questions changed. Do not interpret points on opposite sides of a break as a continuous trend.",
  comparabilityDetails: [
    "2018–2019: comparable annual estimates.",
    "2020: partial-year collection and methodology changes; shown as an isolated point.",
    "2021: virtual-services methodology change; shown as an isolated legacy point.",
    "2022–2023: comparable estimates under the revised treatment measure.",
    "2024: questionnaire changes; not comparable with 2022 or 2023 and shown as an isolated point.",
    "2025: SAMHSA does not show the 2024 treatment estimate in its 2024–2025 comparison table because of 2024 questionnaire changes; shown as an isolated point.",
  ],
  segments: [
    { id: "2018-2019", label: "2018–2019 comparable", color: "#4a43d1" },
    { id: "2020", label: "2020 methodology break", color: "#b50aed" },
    { id: "2021", label: "2021 methodology break", color: "#8b5e34" },
    { id: "2022-2023", label: "2022–2023 comparable", color: "#147986" },
    { id: "2024", label: "2024 questionnaire change", color: "#d55e00" },
    { id: "2025", label: "2025 standalone estimate", color: "#6d28d9" },
  ],
};
